import { sanitizeString } from '../reportingTool/reportingUtils'
import { FormValues } from './formContext'
import { FootageType } from './mediaEvidence'

export const isValidUrl = (url: string) => {
  try {
    const newUrl = new URL(url)
    return newUrl.protocol === 'http:' || newUrl.protocol === 'https:'
  } catch (err) {
    return false
  }
}

export enum Direction {
  next = 'next',
  prev = 'previous',
}

export const convertToFormData = (data: FormValues): FormData => {
  const formData = new FormData()
  formData.append('firstName', sanitizeString(data.firstName))
  formData.append('middleName', sanitizeString(data.middleName))
  formData.append('lastName', sanitizeString(data.lastName))
  formData.append('university', sanitizeString(data.university))
  formData.append('citizenship', sanitizeString(data.citizenship))
  formData.append('professionalTitle', sanitizeString(data.professionalTitle))
  formData.append('biographicalURL', data.biographicalURL)
  formData.append('email', data.email)
  data.representativePhoto.forEach((file, index) => {
    formData.append(`representativePhoto-${index}`, file)
  })

  data.socialMediaInfo.forEach((socialMedia, index) => {
    formData.append(`platform-${index}`, sanitizeString(socialMedia.platform))
    formData.append(`url-${index}`, socialMedia.url)
  })
  data.eventMedia.forEach((event, index) => {
    formData.append(`mediaSource-${index}`, sanitizeString(event.mediaSource))
    formData.append(`eventDate-${index}`, sanitizeString(event.eventDate || ' '))
    if (event.mediaSource === FootageType.Online) {
      formData.append(`mediaUrl-${index}`, event.location)
    } else {
      formData.append(`location-${index}`, sanitizeString(event.location))
    }
    formData.append(`description-${index}`, sanitizeString(event.description))
    event.eventFootage.forEach((file, fileIndex) => {
      formData.append(`eventMedia-${index}-eventFootage-${fileIndex}`, file)
    })
  })
  data.postURLs.forEach((url, index) => {
    formData.append(`postURLs-${index}`, url)
  })

  formData.append('username', sanitizeString(data?.username))
  formData.append('password', sanitizeString(data?.password))
  formData.append('phone', sanitizeString(data?.phone))
  return formData
}
